import bottle from '../../Images/ShopProducts/bottle.jpg'
import facewash from '../../Images/ShopProducts/facewash.jpg'
import headset from '../../Images/ShopProducts/Headset.jpg'
import puma from '../../Images/ShopProducts/Puma Shoe.jpg'
import sunScreen from '../../Images/ShopProducts/Sun Screen.jpg'
import watch from '../../Images/ShopProducts/Watch.jpg'
import sunglass from '../../Images/ShopProducts/sunglass.jpg'
import gamepad from '../../Images/ShopProducts/gamepad.jpg'
import camera from '../../Images/ShopProducts/camera.jpg'
const data = [
    {
        name:'Water Bottle',
        price:13,
        img: bottle
    },
    {
        name:'Face Wash',
        price:29,
        img: facewash
    },
    {
        name:'Sony Headset',
        price:89,
        img: headset
    },
    {
        name:'Puma Shoe',
        price:150,
        img: puma
    },
    {
        name:'Sun Screen',
        price:15,
        img: sunScreen
    },
    {
        name:'Watch',
        price:70,
        img: watch
    },
    {
        name:'Nikon DSLR',
        price:899,
        img: camera
    },
    {
        name:'Sun Glass',
        price:14,
        img: sunglass
    },
    {
        name:'XBOX Gamepad',
        price:35,
        img: gamepad
    },
]
export default data;